﻿import { FC, useState } from "react";
import { CircularProgress, CircularProgressProps, Link, LinkProps } from "@chakra-ui/react";
import { triggerDownloadPrompt } from "../../util";
import { DownloadFunction } from "../DownloadButton";

type DownloadLinkProps = Omit<LinkProps, "onClick"> & {
    downloadFn: DownloadFunction;
    circularProgressProps?: CircularProgressProps;
};

export const DownloadLink: FC<DownloadLinkProps> = ({ downloadFn, children, circularProgressProps, ...linkProps }) => {
    const [downloading, setDownloading] = useState(false);
    const [progress, setProgress] = useState(0);

    return (
        <Link
            display={"inline-block"}
            position={"relative"}
            textDecoration={"underline"}
            onClick={async () => {
                setDownloading(true);
                const { blob, fileName } = await downloadFn(setProgress);
                triggerDownloadPrompt(blob, fileName);
                setDownloading(false);
            }}
            {...linkProps}
        >
            {downloading && (
                <CircularProgress
                    position="absolute"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    isIndeterminate={!progress}
                    value={progress}
                    color={"green.500"}
                    size={"1.5rem"}
                    {...circularProgressProps}
                />
            )}
            {children}
        </Link>
    );
};
